import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const PublishingControls = ({ onPublish }) => {
  const [showModal, setShowModal] = useState(false);
  const [config, setConfig] = useState({
    schedule: 'manual',
    format: 'pdf',
    recipients: [],
    frequency: 'once',
  });

  const handlePublish = () => {
    onPublish?.(config);
    setShowModal(false);
  };

  return (
    <>
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-xl font-semibold text-foreground mb-2">Publishing Controls</h2>
            <p className="text-sm text-muted-foreground">
              Configure scheduling, recipients, and approval workflows for your report
            </p>
          </div>
          <button
            onClick={() => setShowModal(true)}
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors font-medium"
          >
            <Icon name="Send" size={20} />
            Publish Report
          </button>
        </div>
      </div>
      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-card border border-border rounded-lg p-6 max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-2xl font-bold text-foreground">Publish Report</h2>
              <button
                onClick={() => setShowModal(false)}
                className="p-2 rounded-lg hover:bg-muted transition-colors"
              >
                <Icon name="X" size={20} />
              </button>
            </div>

            <div className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-foreground mb-2">
                  Schedule Type
                </label>
                <div className="grid grid-cols-2 gap-2">
                  <button
                    onClick={() => setConfig({ ...config, schedule: 'manual' })}
                    className={`p-3 rounded-lg border text-sm font-medium transition-colors ${
                      config?.schedule === 'manual' ?'border-primary bg-primary/10 text-primary' :'border-border hover:border-primary/50'
                    }`}
                  >
                    Generate Now
                  </button>
                  <button
                    onClick={() => setConfig({ ...config, schedule: 'automated' })}
                    className={`p-3 rounded-lg border text-sm font-medium transition-colors ${
                      config?.schedule === 'automated' ?'border-primary bg-primary/10 text-primary' :'border-border hover:border-primary/50'
                    }`}
                  >
                    Schedule Automated
                  </button>
                </div>
              </div>

              {config?.schedule === 'automated' && (
                <div>
                  <label className="block text-sm font-medium text-foreground mb-2">
                    Frequency
                  </label>
                  <select
                    value={config?.frequency}
                    onChange={(e) => setConfig({ ...config, frequency: e?.target?.value })}
                    className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
                  >
                    <option value="once">Once</option>
                    <option value="daily">Daily</option>
                    <option value="weekly">Weekly</option>
                    <option value="monthly">Monthly</option>
                    <option value="quarterly">Quarterly</option>
                  </select>
                </div>
              )}

              <div>
                <label className="block text-sm font-medium text-foreground mb-2">
                  Export Format
                </label>
                <div className="grid grid-cols-3 gap-2">
                  {['pdf', 'excel', 'word']?.map((format) => (
                    <button
                      key={format}
                      onClick={() => setConfig({ ...config, format })}
                      className={`p-3 rounded-lg border text-sm font-medium transition-colors capitalize ${
                        config?.format === format
                          ? 'border-primary bg-primary/10 text-primary' :'border-border hover:border-primary/50'
                      }`}
                    >
                      {format}
                    </button>
                  ))}
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-foreground mb-2">
                  Recipients
                </label>
                <input
                  type="text"
                  placeholder="Enter email addresses separated by commas"
                  className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground"
                  onChange={(e) =>
                    setConfig({ ...config, recipients: e?.target?.value?.split(',')?.map((r) => r?.trim()) })
                  }
                />
              </div>

              <div className="flex gap-3 pt-4 border-t border-border">
                <button
                  onClick={handlePublish}
                  className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors font-medium"
                >
                  <Icon name="Send" size={20} />
                  {config?.schedule === 'manual' ? 'Generate & Send' : 'Schedule Report'}
                </button>
                <button
                  onClick={() => setShowModal(false)}
                  className="px-4 py-3 bg-muted text-foreground rounded-lg hover:bg-muted/80 transition-colors font-medium"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PublishingControls;